export default {
  product: {
    name: 'Comprar cartão oferta',
  },
  description: {
    items: {
      delivery: 'Enviado imediatamente por e-mail em PDF',
      usage: {
        online: 'Utilizável apenas online',
        online_and_store: 'Utilizável online e no restaurante',
      },
      value: 'Valores flexíveis de {{from}} a {{to}}',
    },
  },
};
